<!--
 * @Author: your name
 * @Date: 2021-06-04 14:46:38
 * @LastEditTime: 2021-06-04 17:16:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \e6-module-order-waybill-process\src\e6-module-order-waybill-process\views\rules\delegateRule\update.vue
-->
<template>
  <add-or-update :pageType="1" />
</template>

<script>
import addOrUpdate from "./components/addOrUpdate";
export default {
  name: "delegateRuleUpdate",
  components: { addOrUpdate }
};
</script>
